export default __webpack_public_path__ + "static/media/banner with text-02.c46bbf15.jpg";